"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var validators_1 = require("./validators");
var helpers_1 = require("./helpers");
var Color = /** @class */ (function () {
    function Color(r, g, b, a) {
        if (a === void 0) { a = 1; }
        this.yiqContrastedThreshold = 150;
        (0, validators_1.validateAlphaValue)(a);
        this.r = r;
        this.g = g;
        this.b = b;
        this.a = a;
    }
    Color.prototype.toRGBString = function () {
        return "rgb(".concat(Math.floor(this.r * this.a), ",").concat(Math.floor(this.g * this.a), ",").concat(Math.floor(this.b * this.a), ")");
    };
    Color.prototype.toRGBAString = function () {
        return "rgba(".concat(this.r, ",").concat(this.g, ",").concat(this.b, ",").concat(this.a, ")");
    };
    Color.prototype.toHexString = function () {
        return (0, helpers_1.rgbaToHex)(this);
    };
    Color.prototype.isDarkColor = function () {
        var yiq = (this.r * 299 + this.g * 587 + this.b * 114) / 1000;
        if (yiq >= this.yiqContrastedThreshold) {
            return false;
        }
        else {
            return true;
        }
    };
    return Color;
}());
exports.default = Color;
